import React, {  useEffect } from 'react';
import { Typography, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Button, FormControl, InputAdornment, IconButton, CircularProgress, Grid, Box, Tooltip } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const RootContainer = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    border-radius: 2%;
    padding: ${({ theme }) => theme.spacing(0)};
    width: 100%;
`

const Container = styled.div`
    display: flex;
    flex-direction: row;
    ${({ theme }) => theme.breakpoints.down('sm')} {
        flex-direction: column;
    }
`

const TableWrapper = styled(TableContainer)`
    display: flex;
    flex-direction: column;
    max-height: 245px;
    height: 245px;
    ${({ theme }) => theme.breakpoints.down('sm')} {
        max-height: 200px;
        height: 200px;
    },
    ${({ theme }) => theme.breakpoints.down('xs')} {
        max-height: 150px;
        height: 150px;
    },
    overflow-y: auto;
`

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: ${({ theme }) => theme.spacing(0)};
    ${({ theme }) => theme.breakpoints.down('sm')} {
        transform: rotate(90deg);

    },
    ${({ theme }) => theme.breakpoints.down('xs')} {
        transform: rotate(0deg);
    },
    ${({ theme }) => theme.breakpoints.down('md')} {
        transform: rotate(0deg);
    },


    & button {
        margin: ${({ theme }) => theme.spacing(1)};
    },
    & button:first-of-type {
        margin-top: 0;
    },


`

const TransferList = (props) => {
    const { t } = useTranslation()

    useEffect(() => {

        if(props.paycodes.length > 0 &&  props.loadingTransfer){

            props.setAvailableItems(props.paycodes.map(item => item))
            props.setLoadingTransfer(false);
        }

    }, [props]);

    const filterAvailableItems = props.availableItems.filter(item =>
        item.name.toLowerCase().includes(props.searchTermAvailable.toLowerCase())
    );

    const filterTransferredItems = props.transferredItems.filter(item =>
        item.name.toLowerCase().includes(props.searchTermTransferred.toLowerCase())
    );

    const moveToSelected = () => {
        props.setTransferredItems(prevTransferred => {
            const newTransferred = [...prevTransferred];
            props.selectedItems.forEach(item => {
                if (!newTransferred.includes(item)) {
                    newTransferred.push(item);
                }
            });
            return newTransferred;
        });
        props.setAvailableItems(prevAvailable => prevAvailable.filter(item => !props.selectedItems.includes(item)));
        props.setSelectedItems([]);
        props.setSelectAllAvailable(false)
        props.setMovePaycodes(false);

    };

    const moveToAvailable = () => {
        props.setAvailableItems(prevAvailable => {
            const newAvailable = [...prevAvailable];
            props.selectTransferItems.forEach(item => {
                if (!newAvailable.includes(item)) {
                    newAvailable.push(item);
                }
            });
            return newAvailable;
        });
        props.setTransferredItems(prevTransferred => prevTransferred.filter(item => !props.selectTransferItems.includes(item)));
        props.setSelectTransferItems([]);
        props.setSelectAllTransferred(false);

        if(props.selectTransferItems.find(item => item.paycode_id === props.selected_paycodes_extra_consecutive_days)){
             props.setSelectedPaycodesExtraConsecutiveDays('');
        }

        if(props.selectTransferItems.find(item => item.paycode_id === props.selected_paycodes_extra_limit)){
            props.setSelectedPaycodesExtraLimit('');
        }


    };

    return (
        <Box sx={{ mt: 1.5 }}>
            <Container>
                <RootContainer>
                    <Typography sx={{marginY: 1.5 , textAlign: 'center'}} variant="body1">{t('settings.credit_holiday_rule.dialog.inputs.available')}</Typography>
                    <FormControl fullWidth sx={{p: 0.8}}>
                        <TextField
                            label={t('settings.credit_holiday_rule.dialog.inputs.search')}
                            size="small"
                            value={props.searchTermAvailable}
                            onChange={(e) => { props.setSearchTermAvailable(e.target.value.toLowerCase()) }}
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton>
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }
                            }}
                            type="search"
                            disabled={props.disabled}
                        />
                    </FormControl>
                    {
                        props.loadingTransfer ? (
                            /* mostrar un  CircularProgress centrado */
                            <Grid container justifyContent="center" alignItems="center" >
                                <CircularProgress color="success" size={20}/>
                            </Grid>

                        )  :
                        (
                            <TableWrapper disabled={props.disabled}>
                                <Table disabled={props.disabled} stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell padding="checkbox" style={{ backgroundColor: '#212121'}}>
                                                <Checkbox
                                                    onChange={() => { !props.selectAllAvailable ? props.setSelectedItems(props.availableItems) : props.setSelectedItems([]); props.setSelectAllAvailable(!props.selectAllAvailable) }}
                                                    checked={props.selectAllAvailable}
                                                />
                                            </TableCell>
                                            <TableCell style={{ backgroundColor: '#212121'}}><Typography variant='body2'>{t('settings.credit_holiday_rule.dialog.inputs.paycodes')}</Typography></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody disabled={props.disabled}>
                                        {filterAvailableItems.map((item, index) => {
                                            const labelId = `enhanced-table-checkbox-${index}`
                                            return (
                                                <Tooltip key={`tooltip_${index}`} title={`${item.type}`} placement="right" arrow>
                                                    <TableRow
                                                        disabled={props.disabled}
                                                        hover
                                                        key={item.paycode_id}
                                                        role="checkbox"
                                                        aria-checked={props.selectedItems.includes(item)}
                                                        selected={props.selectedItems.includes(item)}
                                                        sx={{cursor: 'pointer'}}
                                                        onClick={() => { props.setSelectedItems(prevSelected => { return prevSelected.includes(item) ? prevSelected.filter(selected => selected !== item) : [...prevSelected, item] }) }}
                                                    >
                                                    <TableCell padding='checkbox'>
                                                        <Checkbox
                                                            color='primary'
                                                            checked={props.selectedItems.includes(item)}
                                                            slotProps={{
                                                                input: {
                                                                    'aria-labelledby': labelId,
                                                                }
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" id={labelId} sx={{ maxWidth: '170px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.name}</TableCell>
                                                </TableRow>
                                                </Tooltip>

                                            )
                                        })
                                        }
                                    </TableBody>
                                </Table>
                            </TableWrapper>
                        )
                    }
                </RootContainer>

                <ButtonContainer disabled={props.disabled}>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={moveToSelected}
                        disabled={props.selectedItems.length === 0}
                    >
                        <ArrowForwardIosIcon />
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={moveToAvailable}
                        disabled={props.selectTransferItems.length === 0}
                    >
                        <ArrowBackIosNewIcon />
                    </Button>
                </ButtonContainer>
                <RootContainer disabled={props.disabled}>
                    <Typography sx={{marginY: 1.5 , textAlign: 'center'}} variant="body1">{t('settings.credit_holiday_rule.dialog.inputs.selected')}</Typography>
                    <FormControl fullWidth sx={{p: 0.8}}>
                        <TextField
                            label={t('settings.credit_holiday_rule.dialog.inputs.search')}
                            size="small"
                            value={props.searchTermTransferred}
                            onChange={(e) => { props.setSearchTermTransferred(e.target.value.toLowerCase()) }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton>
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            type="search"
                            disabled={props.disabled}
                        />
                    </FormControl>
                    {props.loadingTransfer ?
                        <Grid container justifyContent={'center'} alignContent={'center'}>
                        <CircularProgress color="success" size={20}/>
                        </Grid>
                        :
                        (
                            <TableWrapper disabled={props.disabled}>
                                <Table disabled={props.disabled} stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell padding='checkbox' style={{ backgroundColor: '#212121'}}>
                                                <Checkbox
                                                    onChange={() => { !props.selectAllTransferred ? props.setSelectTransferItems(props.transferredItems) : props.setSelectTransferItems([]); props.setSelectAllTransferred(!props.selectAllTransferred) }}
                                                    checked={props.selectAllTransferred}
                                                    disabled={props.disabled}
                                                />
                                            </TableCell>
                                            <TableCell style={{ backgroundColor: '#212121'}}><Typography variant='body2'>{t('settings.credit_holiday_rule.dialog.inputs.paycodes')}</Typography></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody disabled={props.disabled}>
                                        {filterTransferredItems.map((item, index) => {
                                            const labelId = `enhanced-table-checkbox-${index}`
                                            return (
                                                <Tooltip key={`tooltip_2${index}`} title={`${item.type}`} placement="right" arrow>
                                                    <TableRow
                                                    disabled={props.disabled}
                                                    hover
                                                    key={item.paycode_id}
                                                    sx={{cursor: 'pointer'}}
                                                    onClick={() => { props.setSelectTransferItems(prevSelected => { return prevSelected.includes(item) ? prevSelected.filter(selected => selected !== item) : [...prevSelected, item] }) }}
                                                    role="checkbox"
                                                    aria-checked={props.selectTransferItems.includes(item)}
                                                    selected={props.selectTransferItems.includes(item)}
                                                    >
                                                    <TableCell padding='checkbox'>
                                                        <Checkbox
                                                            color='primary'
                                                            checked={props.selectTransferItems.includes(item)}
                                                            inputProps={{
                                                                'aria-labelledby': labelId,
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" sx={{ maxWidth: '170px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.name}</TableCell>
                                                </TableRow>
                                                </Tooltip>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableWrapper>
                        )
                    }

                </RootContainer>
            </Container>
            {/* <Button sx={{ mt: 1.5}} onClick={() => console.log('asignando')} variant="outlined" color="error" disabled={props.transferredItems.length === 0}>Asignar</Button> */}
        </Box>
    );
};

export { TransferList };
